// @ts-check

import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material';

const listStyle = {
    paddingTop: '0',
    paddingBottom: '0',
};

const menuItemStyle = {
    paddingTop: '0',
    paddingBottom: '0',
    minHeight: '40px',
    lineHeight: '40px',
    fontSize: 20,
};

const iconStyle = {
    height: '16px',
    width: '16px',
    fontSize: 16,
};

/**
 * Dropdown menu component for FolderUI.
 * @typedef {import('react').MouseEventHandler<HTMLLIElement>} MouseEventHandler_HTMLLIElement
 * @typedef DropdownProps
 * @prop {Element} [anchorEl]
 * @prop {boolean} [open]
 * @prop {(event: {}, reason: "backdropClick" | "escapeKeyDown") => void} [onClose]
 * @prop {MouseEventHandler_HTMLLIElement} [onRename]
 * @prop {number} [count]
 * @prop {boolean} [sync]
 * @prop {boolean} [public]
 * @prop {(id: string, type: string, sync: boolean) => void} [onMove]
 * @prop {(id: string, type: string) => void} [onRemove]
 * @prop {(sync: boolean) => void} [onSync]
 * @prop {(public: boolean) => void} [onPublic]
 *
 * @param {DropdownProps} props
 */
export default function Dropdown(props) {
    return (
        <Menu
            anchorEl={props.anchorEl}
            onClose={props.onClose}
            open={props.open ?? false}
            style={listStyle}
            // @ts-ignore
            width={'150px'}
        >
            {props.count === 1 && (
                <MenuItem
                    style={menuItemStyle}
                    // innerDivStyle={innerItemStyle}
                    onClick={props.onRename}
                >
                    <ListItemIcon style={{minWidth: 30}}>
                        <i className='material-icons' style={iconStyle}>
                            mode
                        </i>
                    </ListItemIcon>
                    <ListItemText primary='Rename' />
                </MenuItem>
            )}
        </Menu>
    );
}
